var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"offset-md5":"","offset-xs2":"","offset-sm3":""}},[_c('v-btn',{staticClass:"button",attrs:{"href":"/#/","color":"success"}},[_vm._v("Visualizar Formulário !")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }